import TemplateView from "../../../TemplateView";
import messageResource from '../../../messageResource'
import Switcher from "../../../components/Switcher";
import ApproversDialogWrapper from '../components/ApproversDialogWrapper'
import {managerLower} from '../../../util/pluralizeUtils'

export default class TimeTrackApprovalSetting extends TemplateView {
    constructor($containerEl)
    {
        super($containerEl);
        this.updateOnInit = false;

        this.state = {
            requiresTTApproval: null,
            nameGroup: null,
            editable: false,
            approvers: [],
            isUGREnabled: false,
            isTTAEnabled: false,
            loaded: false,
        };

        this.onStateChanged(() => this.update());

        this.onStatePropertyChanged('loaded', loaded => {
            this.timetrackApprovalCheckbox.setState({animated: loaded})
        })
    }

    templateHtml()
    {
        return "<div class='sectionHeader'><%=timetrack_approval_settings_header%></div>" +
               "<div class='timeTrackApprovalSetting'>" +
               "   <div class='sectionContent'>" +
               "      <table class='autoApprovalRow'>" +
               "        <tr>" +
               "          <td class='title'><%=button_title%></td>" +
               "          <td class='tumbler'></td>" +
               "          <td class='errorNote'></td>" +
               "          <td class='infoNote'></td>" +
               "          <td class='automaticApproveNote'><%=automatic_message%></td>" +
               "        </tr>" +
               "      </table>" +
               "   </div>" +
               "</div>";
    }

    messageKeys()
    {
        return {
            button_title: 'user.edit.timetrack_settings.approval.button',
            timetrack_approval_settings_header: 'user.edit.timetrack_settings.approval.header',
            automatic_message: "user.edit.timetrack_settings.approval.auto_info"
        }
    }

    afterRender()
    {
        this.$error = this.find(".errorNote");
        this.$info = this.find(".infoNote");
        this.$tumbler = this.find(".tumbler");
        this.$auto = this.find(".automaticApproveNote");

        this.timetrackApprovalCheckbox = new Switcher({
            additionalClass: 'small',
            onSwitchCallback: (isEnabled) => this.$tumbler.trigger("changed", isEnabled)
        }).init(this.find(".tumbler"));

        this.approversDialog = new ApproversDialogWrapper().init(this.$containerEl)

        const self = this;
        this.$tumbler.on('changed',
            (e, isEnabled) =>
            {
                if (self.state.requiresTTApproval !== isEnabled) {
                    self.setState({requiresTTApproval: isEnabled});
                    self.trigger('changeApprovalState', [isEnabled]);
                }
            });

        this.$containerEl.toggle(this.state.isTTAEnabled)
    }

    update()
    {
        this.$containerEl.toggle(this.state.isTTAEnabled);

        this.timetrackApprovalCheckbox.setState({
            enabled: this.state.requiresTTApproval,
            readOnly: !this.state.editable,
        });

        this.$auto.hide();
        this.$error.hide();
        this.$info.hide();

        if (!this.state.editable)
            return

        if (!this.state.requiresTTApproval) {
            this.$auto.show();
        }
        else if (!!this.state.approvers && this.state.approvers.length > 0)
        {
            const infoTitle = `
<span class='firstPart'>${messageResource.getMessage("user.edit.timetrack_settings.approval.info.title.first")}</span>
<span class='secondPart'>${this.state.approvers.length} ${managerLower(this.state.approvers.length)}</span>
`

            this.approversDialog.setState({
                approvers: this.state.approvers,
            })

            this.$info.html(infoTitle);

            const $secondPart = this.$info.find(".secondPart")

            $secondPart.click(() => {
                this.approversDialog.showAt($secondPart, {
                    my: "center top",
                    at: "center bottom",
                })
                this.approversDialog.update()
            })

            this.$info.show();
        }
        else
        {
            this.$error.text(messageResource.getMessage("user.edit.timetrack_settings.approval.error.no_approvers"));
            this.$error.show();
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/user/accountSettings/TimeTrackApprovalSetting.js